import React, { useContext, useEffect, useState } from "react";
import { PropertyContext } from "../context/property-context-v2";
import { PropertyList } from "./PropertyList";

interface Props {
  visible: boolean;
}

const ListingsNew: React.FunctionComponent<Props> = ({ visible }) => {
  const { properties, isLoading } = useContext(PropertyContext);
  const mobileVisibilityClasses = visible
    ? "mobile:visible"
    : "mobile:invisible mobile:absolute";
  const [locationInfo, setLocationInfo] = useState<{
    city: string | null;
    state: string | null;
  }>({
    city: null,
    state: null,
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cityFromUrl = params.get("city");
    const stateFromUrl = params.get("state");
    setLocationInfo({ city: cityFromUrl, state: stateFromUrl });
  }, [properties]);

  return (
    <div
      className={`flex flex-col w-full xl:w-[50%] pl-6 px-1 lg:px-1 lg:pl-4 h-full overflow-y-scroll overflow-x-hidden pb-4 mobile:pt-4 ${mobileVisibilityClasses}`}
    >
      {isLoading && locationInfo.city && locationInfo.state && (
        <div className="w-full mb-4">
          <p className="font-montserrat">
            Searching homes in {locationInfo.city}, {locationInfo.state} to find
            your best matches.
          </p>
        </div>
      )}

      {!isLoading && properties.length === 0 && (
        <p className="font-montserrat">
          No matching properties found in this area
        </p>
      )}

      {!isLoading && properties.length > 0 && (
        <div className="w-full mb-4">
          <p className="font-montserrat">
            Filter your search to further refine results
          </p>
        </div>
      )}

      <div className="flex flex-wrap w-full">
        {properties.length > 0 && <PropertyList properties={properties} />}
      </div>

      <div className={`${visible ? "visible" : "invisible"} xl:visible`}>
        <turbo-frame id="footer-frame" src="/footer"></turbo-frame>
      </div>
    </div>
  );
};

export default ListingsNew;
